import { api } from "./api";
import { ListRequest, MessageResponse } from "../types/common/commonTypes";
import {
  PaginatedAuditResponse,
  AuditTrailFull,
} from "../types/auditTrailTypes";

/**
 * Inventory Management Service
 *
 * Provides complete integration with all 12 inventory management API endpoints:
 * - Core lot management (CRUD operations)
 * - FIFO allocation engine
 * - Real-time availability tracking
 * - Lot shipping and movement
 * - Comprehensive inventory summaries
 *
 * Auto-generation: Lot numbers are auto-generated by backend (YY-###### format)
 * Example: 24-000001, 24-000002, etc. (resets annually)
 */
const audit_base = "/audit-trail";
export const auditService = {
  // ========================================
  // Core Inventory Lot Management (6 endpoints)
  // ========================================

  list: async (params: ListRequest): Promise<PaginatedAuditResponse> => {
    const response = await api.post(`${audit_base}/search`, params);
    return response.data;
  },

  /**
   * Get a specific inventory lot by ID
   * GET /api/v1/inventory/lots/{lot_id}
   */
  getRecordHistory: async (
    table: string,
    id: string,
  ): Promise<AuditTrailFull[]> => {
    const response = await api.get(`${audit_base}/record/${table}/${id}`);
    return response.data;
  },
  getUserHistory: async (id: string): Promise<AuditTrailFull[]> => {
    const response = await api.get(`${audit_base}/user/${id}/activity`);
    return response.data;
  },
};
